export default __webpack_public_path__ + "static/media/maltaimg2.c0ca4f11.jfif";